import { useStore } from '../store';
import { PermissionSlug } from '../constants/featureFlags';

/**
 * Whether this user may see workload beside a clinician's name.
 *
 * Its own module, deliberately kept clear of the API layer: two surfaces need
 * the answer without needing the data. The batch-schedule dialog says *why*
 * loads are absent there, and saying that to someone who has never seen a load
 * would be describing a feature they do not have — so it needs the gate and
 * nothing else.
 *
 * `emr:manage` rides alongside the dedicated slug because the people who author
 * the values must be able to see what they produce.
 *
 * The agency must have Roger EMR enabled as well. `emr:manage` is the
 * agency-admin permission rather than an EMR one, so on its own it does not
 * say the agency has any EMR tasks to price. The backend refuses the load
 * request on the same boundary; checking it here keeps the annotation from
 * rendering, asking, and being refused.
 */
export function useCanViewSchedulingPointLoads(): boolean {
  const hasAnyPermission = useStore(state => state.hasAnyPermission);
  const isRogerEmrEnabled = useStore(
    state => state.user?.agency?.is_rogeremr_enabled === true
  );
  return (
    isRogerEmrEnabled &&
    hasAnyPermission([
      PermissionSlug.SCHEDULING_POINTS_VIEW_LOAD,
      PermissionSlug.EMR_MANAGE,
    ])
  );
}
